export default "__VITE_ASSET__6b2cfbf0__"